import { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'components/common/icons';
import { Dropdown } from 'components/common/dropdown';

export default connect((state) => state)(
  class extends Component {
    handleTypeChange = async (ev) => {
      let type = ev.target.getAttribute('data-type');
      await this.props.updateCourses({ type });
    };

    render() {
      const { messages, type } = this.props;

      const types = {
        default: messages.profileOwnCourses,
        accessible: messages.profileAccessibleCourses,
        administered: messages.profileAdministeredCourses
      };

      return (
        <Dropdown category="lighter" showArrow={true} title={types[type]}>
          {Object.keys(types).map((key) => (
            <button
              key={key}
              data-type={key}
              onClick={this.handleTypeChange}
              style={{ paddingRight: 40, position: 'relative' }}
            >
              {types[key]}
              {key === type ? (
                <Icon
                  icon="check"
                  style={{
                    fontSize: '1rem',
                    position: 'absolute',
                    right: '12px',
                    top: '13px'
                  }}
                />
              ) : null}
            </button>
          ))}
        </Dropdown>
      );
    }
  }
);
